import { createAction } from '@reduxjs/toolkit';

/**
 * CHKM-4023 round 2 (Item 5): `resetAppState` lives in its own leaf module that
 * imports nothing from `store.ts` or any slice, so slices (namely `authSlice.ts`)
 * can dispatch it without re-introducing a value-level import cycle back through
 * `store.ts`.
 *
 * This used to be defined in `store.ts`, which `authSlice.ts` imported directly
 * (`import { resetAppState } from '../store/store'`). That was safe only by
 * accident of import order: `App.tsx` imported `store` before it imported
 * `loadingInterceptors` (which imports `authSlice`), so `store.ts` always
 * finished evaluating — and its `combineReducers({ auth: authSlice, ... })` call
 * always saw a fully-initialized `authSlice` — before anything could enter via
 * `authSlice.ts`. `loadingInterceptors.ts` added a third entry point into that
 * cycle with no such ordering guarantee: importing it directly (as
 * `loadingInterceptors.test.ts` does) evaluates `authSlice.ts` first, which pulls
 * in `store.ts` while `authSlice`'s own default export is still `undefined`,
 * producing a store with `combineReducers` warning `"No reducer provided for key
 * auth"` and no `auth` reducer at all. Moving the leaf action out removes the
 * only value-level `authSlice -> store` edge, so no import order can trigger this.
 */
export const resetAppState = createAction('LOGOUT');
